import React from "react";
import Header from "../sections/Header";
import Hero from "../sections/Hero";
import About from "../sections/About";
import Services from "../sections/Services";
import Tools from "../sections/Tools";
import CaseStudies from "../sections/CaseStudies";
import Gallery from "../sections/Gallery";
import FAQ from "../sections/FAQ";
import Contact from "../sections/Contact";
import Footer from "../sections/Footer";
import WhatsAppFab from "../components/WhatsAppFab";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Tools />
        <CaseStudies />
        <Gallery />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
